/* Everden storefront helpers.
   1. Rating badge under the product title.
   2. Rescues dead buttons (anchors with no href) by sending
      them to the variant picker.

   This theme sets overflow:hidden on html and body and scrolls an
   inner .page-wrapper instead, so scrollIntoView is unreliable.
   We scroll the real container directly, then fall back to native
   focus scrolling if nothing moved. */
(function () {
  var tries = 0;

  /* ---------- SCROLLING ---------- */

  function scrollableAncestor(el) {
    var n = el.parentElement;
    while (n && n !== document.documentElement) {
      var o = window.getComputedStyle(n).overflowY;
      if ((o === 'auto' || o === 'scroll') && n.scrollHeight > n.clientHeight + 10) return n;
      n = n.parentElement;
    }
    return null;
  }

  function readScroll(sc) {
    if (sc) return sc.scrollTop;
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function goTo(target, offset) {
    if (!target) return;
    offset = offset || 24;

    var sc = scrollableAncestor(target);
    var startedAt = readScroll(sc);

    if (sc) {
      var top = target.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - offset;
      if (top < 0) top = 0;
      try {
        sc.scrollTo({ top: top, behavior: 'smooth' });
      } catch (e) {
        sc.scrollTop = top;
      }
    } else {
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        target.scrollIntoView();
      }
    }

    target.setAttribute('tabindex', '-1');

    /* If nothing actually moved, let the browser do it natively.
       focus() without preventScroll always scrolls the element
       into view, whatever the overflow setup. */
    setTimeout(function () {
      if (Math.abs(readScroll(sc) - startedAt) < 8) {
        target.focus();
      } else {
        target.focus({ preventScroll: true });
      }
    }, 400);
  }

  /* ---------- 1. RATING BADGE ---------- */

  function star(fill) {
    return '<svg viewBox="0 0 20 20" width="15" height="15" aria-hidden="true" focusable="false">' +
      '<path d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z" ' +
      'fill="' + (fill ? '#e0894b' : 'rgba(18,55,42,0.18)') + '"/></svg>';
  }

  function reviewsTarget() {
    return document.getElementById('judgeme_product_reviews') ||
           document.querySelector('.jm-review-widget, .jdgm-widget');
  }

  /* Judge.me prints the average with one decimal (4.8, 5.0).
     Requiring the decimal skips stray digits in the sort menu. */
  function readAverage(header) {
    var nodes = header.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length) continue;
      var t = (el.textContent || '').trim();
      if (!/^[0-5]\.\d$/.test(t)) continue;
      var v = parseFloat(t);
      if (v > 0 && v <= 5) return v;
    }
    return null;
  }

  function readCount(header) {
    var m = (header.innerText || '').match(/(\d[\d,]*)\s*reviews?/i);
    return m ? m[1] : null;
  }

  /* Atlas hides any anchor inside .product__title, so the badge
     goes after that wrapper rather than inside it. */
  function mountPoint() {
    var h1 = document.querySelector('h1');
    if (!h1) return null;
    return h1.closest('.product__title') || h1;
  }

  function buildBadge(rating, count) {
    if (document.querySelector('.everden-badge')) return;

    var mount = mountPoint();
    if (!mount) return;

    var rounded = Math.round(rating);
    var stars = '';
    for (var i = 1; i <= 5; i++) stars += star(i <= rounded);

    var a = document.createElement('a');
    a.className = 'everden-badge';
    a.href = '#judgeme_product_reviews';
    a.setAttribute('aria-label', 'Rated ' + rating.toFixed(1) + ' out of 5 from ' + count + ' customer reviews. Jump to reviews.');
    a.innerHTML =
      '<span class="everden-badge__stars" aria-hidden="true">' + stars + '</span>' +
      '<span class="everden-badge__text">' + rating.toFixed(1) + ' (' + count + ' reviews)</span>';

    a.addEventListener('click', function (e) {
      var t = reviewsTarget();
      if (!t) return;
      e.preventDefault();
      goTo(t, 24);
    });

    mount.insertAdjacentElement('afterend', a);
  }

  function scrapeReviews() {
    var header = document.querySelector('.jm-review-widget__header, .jdgm-rev-widg__header');
    if (!header) return false;
    var rating = readAverage(header);
    var count = readCount(header);
    if (rating === null || !count) return false;
    buildBadge(rating, count);
    return true;
  }

  function poll() {
    if (scrapeReviews()) return;
    if (++tries > 60) return;
    setTimeout(poll, 400);
  }

  /* ---------- 2. DEAD BUTTON RESCUE ----------
     Atlas renders section buttons as <a class="button"> even when
     no link is set, so they look clickable and do nothing. Matching
     on the missing href rather than the label means the copy can
     change freely without breaking this. */

  function buyTarget() {
    return document.querySelector('[class*="variant_picker"], [class*="variant-picker"]') ||
           document.querySelector('[class*="product-page-price"]') ||
           document.querySelector('h1');
  }

  function rescueButtons() {
    var dead = document.querySelectorAll('#MainContent a.button:not([href]), #MainContent a.button[href=""]');
    for (var i = 0; i < dead.length; i++) {
      var el = dead[i];
      if (el.dataset.everdenWired) continue;
      el.dataset.everdenWired = '1';
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.style.cursor = 'pointer';

      el.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(buyTarget(), 90);
      });

      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          goTo(buyTarget(), 90);
        }
      });
    }
  }

  function start() {
    poll();
    rescueButtons();
    setTimeout(rescueButtons, 1500);
    setTimeout(rescueButtons, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
